import { render, staticRenderFns } from "./IndexConsult.vue?vue&type=template&id=a9aca644&"
import script from "./IndexConsult.vue?vue&type=script&lang=js&"
export * from "./IndexConsult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9aca644')) {
      api.createRecord('a9aca644', component.options)
    } else {
      api.reload('a9aca644', component.options)
    }
    module.hot.accept("./IndexConsult.vue?vue&type=template&id=a9aca644&", function () {
      api.rerender('a9aca644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/knowledge/IndexConsult.vue"
export default component.exports